export interface IDosageUnity {
  ocorrenciaNo: number;
  codigo: number;
  titulo: string;
  habilitado: boolean;
}
